export default {
   errorMsg:{
      required:"Field is required",
      minValue:"Number must greater than ",
      maxValue:"Number must smaller than ",
      minLength:"Enter letters should be more than ",
      maxLength:"Enter letters should be less than ",
      numeric: "Please enter numeric only",
      decimal: "Please enter valid number",
      policy: "Field contains alpha, number, and '-' only",
      email: "Please enter valid email",
      alphaNum: "Please enter alpha or numeric",
      between: "Number must between ",
      between_and: " and ",
    },
    alertMsg:{
      error:"Some fields missed or invalid, please check items in RED and resubmit.",
      
    },

}


// WEBPACK FOOTER //
// ./src/Validation/langs/en_us/index.js